import React, { useState, useEffect } from "react";
import { useListRefreshListener } from "../../../utils/listNavigation";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { callSearchCustomer } from "../../../api/callcenters/service"
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import { encodeBase64, handleGetCookie } from "../../../utils/commonUtil"
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import RecordsTableFilter from "../../../components/table-filter"
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../components/paginations";
import moment from "moment";
import SmartTable from "../../../components/common/table-component";

const Index = () => {
	let baseUrl = "/admin/callcenter/customerService/save";
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [request, setRequest] = useState({ page: 1, maxResult: 10, keyword: '', modifiedCode: '', modifiedName: '' });
	const [customerList, setCustomerList] = useState([]);
	const [totalPages, setTotalPages] = useState(1);
	const [totalRecord, setTotalRecord] = useState(1);

	useEffect(() => {
		loadData();

		const authData = handleGetCookie('auth');
		if (authData?.user?.userId) {
			setRequest((prev) => ({
				...prev,
				modifiedCode: authData?.user?.userId,
				modifiedName: authData?.user?.firstName + " " + (authData?.user?.lastName === null ? '' : authData?.user?.lastName),
			}));
		}

	}, [request.page, request.maxResult]);

	const loadData = async () => {
		let data = { page: request.page, maxResult: request.maxResult, keyword: request.keyword };
		const rsp = await dispatch(callSearchCustomer(data));
		console.log(rsp)
		if (rsp?.payload?.responseCode === "00000") {
			setCustomerList(rsp.payload.data.result);
			setTotalPages(rsp.payload.data.totalPages);
			setTotalRecord(rsp.payload.data.totalRecords)
		}
	};

	const handlePageChange = (pageNumber) => {
		if (pageNumber >= 1 && pageNumber <= totalPages) {
			setRequest((prev) => ({ ...prev, page: pageNumber }));
		}
	};

	const handleChange = (e) => {
		setRequest((prev) => ({ ...prev, keyword: e.target.value }));
	};

	const onSearch = async (e) => {
		e.preventDefault()
		loadData()
	}

	const handleEdit = (id) => {
		navigate(baseUrl + "/" + encodeBase64(id))
	}

	useListRefreshListener(loadData);

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						<h4>{t("menu.callcenter.customer")}</h4>

						<div className="group-button-header">
							<button type="button" className="btn btn-primary" onClick={() => navigate(baseUrl)}>
								<i className="fas fa-plus"></i> {t("button.add")}
							</button>
						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="row">
											<div className="col-md-3">
												<div className="form-group">
													<label>{t('search.keyword')}</label>
													<input
														type="text"
														name="keyword"
														className="form-control-uld"
														placeholder={t('search.keyword') + "..."}
														onChange={handleChange}
														value={request.keyword}
														autoComplete="off"
														required />
												</div>
											</div>
											<div className="col-auto auto-button">
												<label>&nbsp;</label>
												<button className="theme-btn btn-style-one w-100" onClick={onSearch}>
													<i className="fas fa-search"></i>&nbsp;{t("button.search")}
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>


					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">

										<RecordsTableFilter
											totalRecord={totalRecord}
											perPage={request.maxResult}
											onChange={(e) =>
												setRequest((prev) => ({
													...prev,
													maxResult: Number(e.target.value),
													page: 1,
												}))
											}
										/>

										<SmartTable
	columns={[
							{ labelKey: "callcenter.customerService.id", key: "customerId" },
							{ labelKey: "callcenter.customerService.gender", key: "gender", render: (val) => t('gender.' + val) },
							{ labelKey: "callcenter.customerService.firstName", key: "firstName" },
							{ labelKey: "callcenter.customerService.lastName", key: "lastName" },
							{ labelKey: "callcenter.customerService.status", key: "status", render: (val) => val === 1 ? <span className="badge bg-success">{t('status.active')}</span> : <span className="badge bg-danger">{t('status.inActive')}</span> },
							{ labelKey: "callcenter.customerService.phone", key: "phone" },
							{ labelKey: "callcenter.customerService.isVerify", key: "isVerify", render: (val) => val === 1 ? <span className="badge bg-success">{t('verifyStatus.verify')}</span> : <span className="badge bg-danger">{t('verifyStatus.notVerify')}</span> },
							{ labelKey: "callcenter.customerService.dateOfBirth", key: "dateOfBirth", render: (val) => val ? moment(val).format("DD/MM/YYYY") : '-' },
							{ labelKey: "callcenter.customerService.provinceName", key: "provinceName", style: { minWidth: '150px' } },
							{ labelKey: "callcenter.customerService.districtName", key: "districtName", style: { minWidth: '150px' } },
							{ labelKey: "callcenter.customerService.village", key: "village", style: { minWidth: '150px' } },
							{ labelKey: "callcenter.customerService.documentType", key: "documentType" },
							{ labelKey: "callcenter.customerService.documentNo", key: "documentNo" },
							{ labelKey: "callcenter.customerService.issueDate", key: "issueDate", render: (val) => val ? moment(val).format("DD/MM/YYYY") : '-' },
							{ labelKey: "callcenter.customerService.issuePlace", key: "issuePlace" },
							{ labelKey: "callcenter.customerService.expiredDate", key: "expiredDate", render: (val) => val ? moment(val).format("DD/MM/YYYY") : '-' },
							{ labelKey: "callcenter.customerService.modifiedDate", key: "updatedAt", render: (val) => val ? moment(val).format("DD/MM/YYYY HH:mm:ss") : '-' },
							{ labelKey: "callcenter.customerService.modifiedBy", key: "updatedBy" },
						]}
	data={{ result: customerList }}
	rowKey="customerId"
	recordsTableFilter={false}
	customPagination={false}
	showRowNumber={false}
	actions={(item) => (<button className="btn btn-primary btn-sm" onClick={() => handleEdit(item.customerId)}><i className="fas fa-pen"></i></button>)}
/>

										<CustomPagination
											currentPage={request.page}
											totalPages={totalPages}
											onPageChange={handlePageChange}
											maxVisiblePages={1}
										/>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
